import styled from 'styled-components';

export const MobileDropdownMenuSectionLinkAnchorContainer = styled.div`
    flex-grow: 1;
    padding: 12px 15px;
`;
